module.exports = __webpack_public_path__ + "static/media/iPhone14-1.c2bfb888.png";